// Scss entrypoint


// TYPO3.lang contains all available inline labels
const loadFormValidation = () => import('./Form/validation.js');
const createForm = document.querySelector('form[name="newIconset"],form[name="iconset"]');
if (createForm) {
    loadFormValidation();
}
//console.log("Say hoo!");

/*
// UX-improment to delete files in iconlib records
document.addEventListener("DOMContentLoaded", (event) => {
    let icons = document.querySelectorAll('.deleteIcon');

    icons.forEach(icon => {
        icon.addEventListener('click', (event) => {
            event.preventDefault();
            console.log(icon);
            //const resourcePointer = icon.closest('[name*="resourcePointer"]');
            const grandParent = icon.parentElement.parentElement.parentElement;
            const aiPreview = grandParent.querySelector('.thumb-preview');
            const resourcePointer = grandParent.querySelector('[name*="resourcePointer"]');
            grandParent.removeChild(aiPreview);
            console.log(resourcePointer);
            //resourcePointer.value = '';
            resourcePointer.remove();
            const iconId = icon.dataset.iconId;
            const iconName = icon.dataset.iconName;
            const confirmation = confirm(`Are you sure you want to delete the icon "${iconName}"?`);
            if (confirmation) {
                // Proceed with deletion
                //window.location.href = `/typo3/index.php?route=iconset/deleteIcon&iconId=${iconId}`;
            }
        });
    });
});
*/
